// Válvula de escape: 3 falhas de envio seguidas dão a opção de pular a etapa
// por 24h, mesmo que a elegibilidade (should_fill_data) continue verdadeira —
// senão o usuário fica preso numa etapa que está falhando por causa alheia a
// ele (CEP fora do ar, backend fora do ar).
const STORAGE_KEY = 'onboardingAddressSkippedAt';
const DAY_IN_MS = 24 * 60 * 60 * 1000;

const keyFor = (userId?: number): string =>
  `${STORAGE_KEY}:${userId ?? 'anon'}`;

// Sessão sem storage gravável: sem este fallback o gate lê `false` no
// dashboard, redireciona de volta para a etapa e o usuário fica em loop.
const skippedInMemory = new Map<string, string>();

export function clearOnboardingAddressSkipFallback(): void {
  skippedInMemory.clear();
}

const isWithinSkipWindow = (skippedAt: string, now: Date): boolean => {
  const elapsed = now.getTime() - new Date(skippedAt).getTime();

  return elapsed >= 0 && elapsed < DAY_IN_MS;
};

export function isOnboardingAddressSkipped(
  userId?: number,
  now: Date = new Date(),
): boolean {
  const key = keyFor(userId);

  try {
    const skippedAt = window.localStorage.getItem(key);

    if (skippedAt) {
      return isWithinSkipWindow(skippedAt, now);
    }
  } catch {
    /* storage ilegível: cai no fallback em memória */
  }

  const fallbackSkippedAt = skippedInMemory.get(key);

  return Boolean(fallbackSkippedAt) && isWithinSkipWindow(fallbackSkippedAt!, now);
}

export function skipOnboardingAddress(userId?: number): void {
  const key = keyFor(userId);
  const skippedAt = new Date().toISOString();

  skippedInMemory.set(key, skippedAt);

  try {
    window.localStorage.setItem(key, skippedAt);
  } catch {
    /* sessão sem storage: vale o fallback em memória acima */
  }
}
